import React from "react";
import compose from "../../utils/compose";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
    saveData,
    changeSignalFilters,
    prepareDataForSave,
    signReportData,
    openModalDialog,
    setStimulator
} from "../../redux/actions/report-actions.js";

import "./toolbar.scss";
import SignaturedPdfLink from "../signatured-pdf-link/signatured-pdf-link.js";

import withLocalization from "../../hoc/with-localization";
import withReportDataService from "../../hoc/with-dataservice-consumer";
import { modal_mode_halfscreen } from "../../redux/actions/actionConstants";
import { measurer_dialog } from "../popup-dialog-manager/constants";

import { ReactComponent as SvgRuler } from "../../assets/ruler-compass.svg";
import { ReactComponent as SvgHome } from "../../assets/home-outline.svg";
import { useNavigate } from "react-router-dom";
import ButtonIcon from "../ui/ButtonIcon/ButtonIcon.jsx";

const Toolbar = props => {
    const navigate = useNavigate();

    const onPrintClick = () => {
        window.print();
    };
    const onSave = () => {
        const { saveData } = props;

        saveData();
    };
    const onSignReport = () => {
        const { signReport } = props;
        signReport();
    };

    const onFilterChange = e => {
        const { baseline, _35Hz, _50Hz, spikes, changeSignalFilters, prepareDataForSave } = props;

        const filters = {
            baseline,
            _35Hz,
            _50Hz,
            spikes
        };

        const changedFilters = {};
        const { checked, name } = e.target;
        if (name === "BL") {
            filters.baseline = checked;
            changedFilters.FilterBL = checked;
        }
        if (name === "35") {
            filters._35Hz = checked;
            changedFilters.Filter35 = checked;
        }
        if (name === "50") {
            filters._50Hz = checked;
            changedFilters.Filter50 = checked;
        }
        if (name === "spikes") {
            filters.spikes = checked;
            changedFilters.FilterSpikes = checked;
        }

        prepareDataForSave({ diff: { ...changedFilters } });
        changeSignalFilters(filters);
    };

    const onOpenModal = _win => {
        props.openModalDialog(_win);
    };

    const onSetStimulator = () => {
        const { setStimulator } = props;
        setStimulator(!props.stimulator);
    };
    const onHomeClick = () => {
        navigate("/");
    };

    const {
        needSave,
        resultID,
        signInfo: { signed = false, PDFLink } = {},
        loc,
        editMode,
        baseline,
        SACR_config, // Специальный режим для интеграции в комплекс САКР
        _35Hz,
        _50Hz,
        spikes,
        stimulator,
        anonymousMode,
        Login,
        AppCloseBtn
    } = props;
    const loading = !resultID;
    const closeBtn_exists = AppCloseBtn !== null && AppCloseBtn !== undefined;
    return (
        <div className="toolbar">
            <div className="toolbar__controls-wrap">
                <div className="toolbar__controls">
                    <div className="controls-group toolbar__controls-group">
                        <ButtonIcon onClick={onHomeClick}>
                            <SvgHome />
                        </ButtonIcon>
                    </div>

                    <div className="controls-group toolbar__controls-group">
                        <div className="chbx-wrap">
                            <input type="checkbox" disabled={loading} checked={stimulator} onChange={onSetStimulator} id="chbx_stim" />
                            <label htmlFor="chbx_stim">{loc("buttons.stimulator")}</label>
                        </div>
                        <ButtonIcon text={loc("buttons.measurer")} disabled={loading} onClick={() => onOpenModal(measurer_dialog)}>
                            <SvgRuler />
                        </ButtonIcon>
                    </div>

                    <div className="controls-group toolbar__controls-group toolbar__filters">
                        <div className="filters group">
                            <label className={"label button" + (baseline ? " active" : "") + " disabled"}>
                                {loc("buttons.baseline")}
                                <input type="checkbox" disabled name="BL" checked={baseline} onChange={onFilterChange} />
                            </label>
                            <label className={"label button" + (_35Hz ? " active" : "") + (loading ? " disabled" : "")}>
                                {"35 " + loc("units.Hz")}
                                <input type="checkbox" disabled={loading} name="35" checked={_35Hz} onChange={onFilterChange} />
                            </label>
                            <label className={"label button" + (_50Hz ? " active" : "") + (loading ? " disabled" : "")}>
                                {"50 " + loc("units.Hz")}
                                <input type="checkbox" disabled={loading} name="50" checked={_50Hz} onChange={onFilterChange} />
                            </label>
                            {stimulator && (
                                <label className={"label button" + (spikes ? " active" : "") + (loading ? " disabled" : "")}>
                                    {loc("buttons.stimulusFilter")}
                                    <input type="checkbox" disabled={loading} name="spikes" checked={spikes} onChange={onFilterChange} />
                                </label>
                            )}
                        </div>
                    </div>

                    <div className="controls-group toolbar__controls-group">
                        {SACR_config ? (
                            <button disabled={loading} className={"button button-ok"} onClick={onPrintClick}>
                                {loc("buttons.print")}
                            </button>
                        ) : signed ? (
                            PDFLink ? (
                                <a className="signaturedFile-info__link" href={decodeURI(PDFLink)} target="_blank" rel="noreferrer">
                                    {loc("links.signedFile")}
                                </a>
                            ) : (
                                <SignaturedPdfLink loc={loc} />
                            )
                        ) : editMode ? (
                            <button disabled={loading} className={"button button-ok"} onClick={onSignReport}>
                                {loc("buttons.sign")}
                            </button>
                        ) : null}

                        {editMode ? (
                            <button disabled={!needSave || loading} className="button button-ok" onClick={onSave}>
                                {loc("buttons.save")}
                            </button>
                        ) : null}
                    </div>

                    {closeBtn_exists && <div className="controls-group toolbar__controls-group">{AppCloseBtn}</div>}
                    {!anonymousMode && <div className="controls-group toolbar__controls-group">{Login}</div>}
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = ({
    reportApp: {
        app: {
            editState: { needSave },
            modal,
            settings: { editMode }
        },
        reportData
    }
}) => {
    const { baseline, _35Hz, _50Hz, spikes } = reportData.settings.graphs.signalFilters;
    const { resultID, signInfo } = reportData.report || {};
    return {
        needSave,
        resultID,
        signInfo,
        editMode,

        halfScreenModalOpened: modal.opened && modal.dialogMode === modal_mode_halfscreen,

        baseline,
        _35Hz,
        _50Hz,
        spikes,
        stimulator: reportData?.report?.stimulator || false
    };
};
const mapDispatchToProps = (
    dispath,
    { dataService: { reqSetStimulator, saveData: saveDataAPI, getReportData, check, signReport: signReportAPI, onResIDChangedCallback } }
) => {
    return bindActionCreators(
        {
            prepareDataForSave,
            changeSignalFilters,
            saveData: saveData(saveDataAPI, getReportData, check, onResIDChangedCallback),
            signReport: signReportData(signReportAPI, saveDataAPI, getReportData, check, onResIDChangedCallback),
            setStimulator: setStimulator(reqSetStimulator, saveDataAPI, getReportData, check, onResIDChangedCallback),
            openModalDialog
        },
        dispath
    );
};

export default compose(withLocalization, withReportDataService(), connect(mapStateToProps, mapDispatchToProps))(Toolbar);
